import React, { useState, ChangeEvent, useCallback, useEffect } from "react";
import { ChevronDown, ChevronLeft, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import uploadIcon from "@/assets/icons/upload.svg";
import toastService from "@/services/toastService";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "@/components/ui/select";
import axiosInstance from "@/api/axios";
import { MasterData, MasterDataParam } from "../dialogCompanyDetails/createCompanyDetails";
import { Label } from "@/components/ui/label";
import Autocomplete from "@mui/material/Autocomplete";
import { addBuilderProject, getServiceOffered } from "../services/company-details";
import TextField from "@mui/material/TextField";
import PhoneInput from "../../../questionnaire/ui/input-types/PhoneInput";
// import { InputHTMLAttributes } from "react";
// import { FaOldRepublic } from "react-icons/fa";

interface ProjectImage {
  id: string;
  file: File;
  preview: string;
  isLocal?: boolean
}

export interface BuilderProject {
  projectName: string;
  jobType: string[]; // changed from string to string[]
  projectYear?: number;
  projectAddress: string;
  city: string;
  latitude: number;
  longitude: number;
  builderName: string;
  buildPhone: string;
  builderEmail: string;
  builderWebsite: string;
  country: string;
  province: string;
  region: string;
  county: string;
  projectImages: File[] | null;
  serviceType: string[];
  projectType?: string[];
  // city:string
}
export interface ProjectTypes {
  id?: number;
  name?: string;
  pin_color?: boolean;
  project_class_id?: [number, string]


}


export default function AddNewProject() {
  const navigate = useNavigate();
  // Form state
  const [formData, setFormData] = useState<BuilderProject>({
    projectName: "",
    jobType: [],
    projectYear: 2000,
    projectAddress: "",
    projectType: [],
    // city: "",
    latitude: 0,
    longitude: 0,
    builderName: "",
    buildPhone: "",
    builderEmail: "",
    builderWebsite: "",
    country: "",
    province: "",
    region: "",
    county: "",
    city: "",
    projectImages: [],
    serviceType: []
  });


  // Project images state
  const [projectImagesPreview, setProjectImagesPreview] = useState<ProjectImage[]>([]);
  const [selectedCountryName, setSelectedCountryName] = useState<string>("");
  const [masterData, setMasterData] = useState<Partial<MasterData>>();
  const [selectedProvinceName, setSelectedProvinceName] = useState<string>("");
  const [selectedregionName, setSelectedregionName] = useState<string>("");

  const [selectedcountyName, setSelectedcountyName] = useState<string>("");
  const [selectedcityName, setSelectedcityName] = useState<string>("");
  const [formErrors, setFormErrors] = useState<{ projectYear?: string }>({});
  const [latitudeError, setLatitudeError] = useState<string | null>(null);
  const [longitudeError, setlongitudeError] = useState<string | null>(null);

  const [serviceOffered, setserviceOffered] = useState<
    { id: number; name: string; description: boolean }[]
  >([]);

  const serviceOfferedNames = serviceOffered.map((item) => item.name);
  const [selectedServiceOfferedNames, setSelectedServiceOfferedNames] = useState<string[]>([]);
  const [isPhoneValid, setIsPhoneValid] = useState(true);

  const [projectTypes, setprojectTypes] = useState<
    ProjectTypes[]
  >([]);
  const projectsOfferedNames = Array.from(new Set(projectTypes.map((item) => item.name)));
  const [selectedProjectTypes, setselectedProjectTypes] = useState<string[]>([]);



  const [provinceOptions, setProvinceOptions] = useState<
    {
      country_id: [number, string];
      id: number;
      name: string;
    }[]
  >();

  const [regionOptions, setRegionOptions] = useState<
    {
      id: number;
      name: string;
      state_id: [number, string];
    }[]
  >([]);

  const [cityOptions, setCityOptions] = useState<
    {
      id: number;
      name: string;
      state_id: [number, string];
      region_id: [number, string];
      county_id: [number, string];
    }[]
  >([]);

  const [countyOptions, setCountyOptions] = useState<
    {
      id: number;
      name: string;
      state_id: [number, string];
      region_id: [number, string];
    }[]
  >([]);
  // Check if all required fields are filled
  const isFormValid =
    formData.projectName &&
    selectedProjectTypes.length > 0 &&
    formData.projectYear &&
    formData.projectAddress.trim() &&
    formData.country && formData.province &&
    selectedServiceOfferedNames.length > 0 &&
  // formData.city.trim() &&
  // formData.latitude &&
  // formData.longitude &&
    formData.builderName;
  // formData.buildPhone.trim() &&
  // formData.builderEmail.trim() &&
  // formData.builderWebsite.trim();

  useEffect(() => {
    fetchProjectServicesTypes();
  }, []);

  console.log(isPhoneValid)


  const fetchProjectServicesTypes = useCallback(async () => {
    try {
      const response = await getServiceOffered();
      console.log(response, "line 120");
      console.log(response?.data, "line 122");

      // Extract IDs & Names

      setserviceOffered(response?.data);
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  }, []);

  console.log(projectTypes, "line 182")


  useEffect(() => {
    const callToMaster = async () => {
      const params: Partial<MasterDataParam> = {
        countries: true,
        provinces: true,
        projectClasses: true,
        projectTypes: true,
        projectStatuses: true,
        regions: true,
        counties: true,
        cities: true,
      };
      const data = await getMasterData(params);
      console.log("master data", data);
      setMasterData(data);
      setprojectTypes(data.projectTypes)
    };

    callToMaster();
  }, []);

  console.log(projectTypes, "line 207")
  console.log(selectedProjectTypes, "line 208")

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // Allow empty input
    if (value === "") {
      setFormData((prev) => ({
        ...prev,
        [name]: undefined,
      }));
      if (name === "latitude") setLatitudeError(null);
      if (name === "longitude") setlongitudeError(null);
      return;
    }

    if (name === "latitude") {
      const num = Number(value);
      if (!isNaN(num) && num >= -90 && num <= 90) {
        setFormData((prev) => ({
          ...prev,
          latitude: num,
        }));
        setLatitudeError(null); // Clear error if valid
      } else {
        setLatitudeError("Latitude must be between -90 and 90");
      }
      return;
    }

    if (name === "longitude") {
      const num = Number(value);
      if (!isNaN(num) && num >= -180 && num <= 180) {
        setFormData((prev) => ({
          ...prev,
          longitude: num,
        }));
        setlongitudeError(null); // Clear error if valid
      } else {
        setlongitudeError("Longitude must be between -180 and 180");
      }
      return;
    }

    // For projectYear, allow partial input, but validate when it's 4 digits
    if (name === "projectYear") {
      // Allow only numbers or empty string
      if (/^\d{0,4}$/.test(value)) {
        setFormData((prev) => ({
          ...prev,
          projectYear: value === "" ? undefined : Number(value),
        }));

        // Validate only when 4 digits entered
        if (value.length === 4) {
          console.log("line 275")
          const yearNum = Number(value);
          console.log(yearNum,"line 276")
          // const currentYear = new Date().getFullYear();
          // console.log(currentYear,yearNum,"line 277")

          if (yearNum < 2000 || yearNum > 2050) {
            setFormErrors((prev) => ({
              ...prev,
              projectYear: `Enter a year between 2000 and 2050`,
            }));
          } else {
            setFormErrors((prev) => ({
              ...prev,
              projectYear: "",
            }));
          }
        } else {

          // clear error while typing incomplete year
          setFormErrors((prev) => ({
            ...prev,
            projectYear: "",
          }));
        }
      }
    } else {
      // For other fields
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };





  const getProvinceOptions = useCallback(async (country_id: string) => {
    const d = await getMasterData({
      countryId: Number(country_id),
      provinces: true,
    });
    if (d && d.provinces) setProvinceOptions(d.provinces);
    else {
      setProvinceOptions([]);
    }
  }, []);

  const getCitiesOptions = useCallback(async (county_id: string) => {
    const d = await getMasterData({
      countyId: Number(county_id),
      cities: true,
    });
    if (d && d.cities) {
      setCityOptions(d.cities);

    }
    else {
      setCityOptions([]);

    }
  }, []);

  const getRegionsForProvince = useCallback(
    async (provinceId: string) => {
      if (provinceId) {
        try {
          const data = await getMasterData({
            provinceId: Number(provinceId),
            regions: true,
            cities: true,
          });

          // Check if the response contains regions and update the state
          if (data?.regions || data?.cities) {
            setRegionOptions(data.regions);
            setCityOptions(data.cities);
          } else {
            setRegionOptions([]); // Set empty array if no regions are returned
          }
        } catch (error) {
          console.error("Error fetching regions:", error);
          setRegionOptions([]); // Set empty array in case of error
        }
      } else {
        setRegionOptions([]); // Clear regions if no provinceId
      }
    },
    [] // No dependencies needed, can be added if masterData changes
  );

  const getCountiesForProvinceAndRegion = useCallback(
    async (province_id: string, region_id: string) => {
      if (province_id && region_id) {
        const data = await getMasterData({
          provinceId: Number(province_id),
          regionId: Number(region_id),
          counties: true,
          cities: true,
        });

        if (data?.counties || data?.cities) {
          setCountyOptions(data.counties);
          setCityOptions(data.cities);

        } else {
          setCountyOptions([]);
        }
      } else {
        setCountyOptions([]);
      }
    },
    []
  );

  const getMasterData = async (param: object) => {
    // setIsLoading(true);
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/odoo/api/v1/crm/masterData",
        params: param,
      });
      console.log("response", response);

      return response.data.data;
    } catch (err) {
      console.log("err", err);
    } finally {
      // setIsLoading(false);
    }
  };


  const handleImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const newImages: ProjectImage[] = [];
      const fileArray = Array.from(files);
      const previews: string[] = [];

      fileArray.forEach((file, index) => {
        const imageId = `img_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
        const reader = new FileReader();
        console.log(index)

        reader.onloadend = () => {
          if (typeof reader.result === "string") {
            const preview = reader.result;

            newImages.push({
              id: imageId,
              file,
              preview,
            });

            previews.push(preview);

            //  When all previews are ready
            if (newImages.length === fileArray.length) {
              setProjectImagesPreview((prev) => [...prev, ...newImages]);

              //  Also append files to formData.projectImages array
              setFormData((prev) => ({
                ...prev,
                projectImages: [...(prev.projectImages || []), ...fileArray],
              }));
            }
          }
        };

        reader.readAsDataURL(file);
      });
    }
  };



  // Remove an image
  const removeImage = (id: string) => {
    setProjectImagesPreview((prev) => {
      const filtered = prev.filter((img) => img.id !== id);
      return filtered;
    });
  };

  // Handle form submission
  const handleSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();
    formData.projectType = selectedProjectTypes
    formData.serviceType = selectedServiceOfferedNames
    formData.country = selectedCountryName
    formData.province = selectedProvinceName
    formData.region = selectedregionName
    formData.county = selectedcountyName
    formData.city = selectedcityName

    const newformData = objectToFormData(formData) as FormData;


    // for (let [key, value] of newformData.entries()) {
    //   console.log(`${key}: ${value}`, "line 457");
    // }
    const response = await addBuilderProject(newformData);

    if (response.statusCode === 201) {
      toastService.success("Builder Project Created Successfully")
      navigate("/profile/company-profile");
    }
  };


  const labelStyle = "block text-sm font-medium text-[#616161]";
  // const inputStyle =
  //   "w-full rounded-lg border border-[#e0e0e0] px-3 py-2 placeholder-[#828282] focus:outline-none placeholder:text-sm";

  return (
    <div className="w-full mx-auto p-7 bg-white">
      <div className="w-full">
        <div className="mb-5">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="secondary"
                  className="flex items-center gap-x-1"
                  size="icon"
                  onClick={() => history.back()}
                >
                  <ChevronLeft />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Go Back</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        {/* Project Information */}
        <div className="grid lg:grid-cols-2 xl:grid-cols-3 14xl:grid-cols-4 gap-x-5 gap-y-6 mb-10">
          <div className="space-y-2">
            <label htmlFor="projectName" className={labelStyle}>
              Project Name *
            </label>
            <input
              id="projectName"
              name="projectName"
              className="w-full px-3 border border-gray-300 rounded-md  h-[40px]"
              placeholder="Enter Project Name"
              value={formData.projectName}
              onChange={handleInputChange}
            />
          </div>


          <div className="space-y-2">
            <Label className="block text-sm font-medium mb-2 text-[#616161]">
              Project Types *
            </Label>
            <Autocomplete
              id="auto-partners"
              className="z-20 w-full mb-8"
              options={projectsOfferedNames} // Only name strings
              multiple
              disablePortal
              size="small"
              selectOnFocus
              value={selectedProjectTypes}
              onChange={(_, newValue) => {
                setselectedProjectTypes(newValue as string[]); // Save names only
                // setselectedProjectTypes(newValue.filter((item): item is string => item !== undefined));

              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Project Types"
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": { fontSize: "14px" },
                    "& .MuiChip-root": { fontSize: "14px", height: "24px" },
                    "& .MuiChip-label": { padding: "0 4px" },
                    "& .MuiInputBase-input::placeholder": { fontSize: "14px" },
                  }}
                />
              )}
            />



          </div>

          <div className="space-y-2">
            <Label className="block text-sm font-medium mb-2 text-[#616161]">
              Type of Job *
            </Label>
            <Autocomplete
              id="auto-partners"
              className="z-20 w-full mb-8"
              options={serviceOfferedNames} // Only name strings
              multiple
              disablePortal
              size="small"
              selectOnFocus
              value={selectedServiceOfferedNames}
              onChange={(_, newValue) => {
                setSelectedServiceOfferedNames(newValue); // Save names only
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Work Category"
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": { fontSize: "14px" },
                    "& .MuiChip-root": { fontSize: "14px", height: "24px" },
                    "& .MuiChip-label": { padding: "0 4px" },
                    "& .MuiInputBase-input::placeholder": { fontSize: "14px" },
                  }}
                />
              )}
            />


          </div>


          <div className="space-y-2">
            <label htmlFor="projectYear" className={labelStyle}>
              Completed Year *
            </label>
            <input
              id="projectYear"
              name="projectYear"
              type="number"
              min="2000"
              max="2060"
              className={`w-full px-3 border rounded-md h-[40px] ${formErrors.projectYear ? "border-red-500" : "border-gray-300"
                }`}
              placeholder="Project Completed Year"
              value={formData.projectYear ?? ""}
              onChange={handleInputChange}
              onKeyDown={(e) => {
                // Allow only: ArrowUp, ArrowDown, Backspace, Delete, Tab
                if (
                  !["ArrowUp", "ArrowDown", "Backspace", "Delete", "Tab"].includes(e.key)
                ) {
                  e.preventDefault();
                }
              }}
            />
            {formErrors.projectYear && (
              <p className="text-sm text-red-500">{formErrors.projectYear}</p>
            )}
          </div>


          <div className="space-y-2">
            <label htmlFor="projectAddress" className={labelStyle}>
              Project Address *
            </label>
            <input
              id="projectAddress"
              name="projectAddress"
              className="w-full px-3 border rounded-md h-[40px]"
              placeholder="Enter Project Address"
              value={formData.projectAddress}
              onChange={handleInputChange}
            />
          </div>
          <div className="space-y-2">
            <label
              htmlFor="country"
              className="block text-sm font-medium text-gray-700"
            >
              Country *
            </label>

            <div className="relative">
              <Select
                onValueChange={(selectedValue) => {
                  if (selectedValue === "clear") {
                    setFormData((prev) => ({
                      ...prev,
                      country: "",
                      province: "",
                      region: "",
                      county: "",
                      city: "",
                    }));
                    setSelectedCountryName(""); // Clear the selected country name
                    getProvinceOptions("");
                  } else {
                    console.log("country changed", selectedValue);

                    const selectedCountry = masterData?.countries?.find(
                      (c) => String(c.id) === selectedValue
                    );

                    setSelectedCountryName(selectedCountry?.name ?? "");

                    setFormData((prev) => ({
                      ...prev,
                      country: selectedValue,
                      province: "",
                      region: "",
                      county: "",
                      city: "",
                    }));

                    getProvinceOptions(selectedValue);
                  }
                }}
              // value={formData.country || ""}
              >
                <SelectTrigger className="w-full px-3 border rounded-md h-[40px]">
                  <SelectValue placeholder="Select Country" />
                </SelectTrigger>

                <SelectContent className="max-h-[200px] overflow-y-auto">
                  <SelectItem value="clear" className="text-red-500 italic">
                    Clear selection
                  </SelectItem>

                  {(masterData && masterData?.countries && masterData?.countries?.length > 0) ? (
                    masterData.countries.map((country) => (
                      <SelectItem key={country.id} value={String(country.id)}>
                        {country.display_name}
                      </SelectItem>
                    ))
                  ) : (
                    <SelectItem value="NA" disabled>
                      No data available
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="province" className="block text-sm font-medium text-gray-700">
              Province/State *
            </label>
            <div className="relative">
              <Select
                onValueChange={(selectedValue) => {
                  if (selectedValue === "clear") {
                    setFormData((prev) => ({
                      ...prev,
                      province: "",
                      // provinceName: "",
                      region: "",
                      county: "",
                      city: "",
                    }));
                    getRegionsForProvince("");
                  } else {
                    const selectedProvince = provinceOptions?.find(
                      (prov) => prov.id.toString() === selectedValue
                    );
                    setFormData((prev) => ({
                      ...prev,
                      province: selectedValue,
                      // provinceName: selectedProvince?.name || "",
                      region: "",
                      county: "",
                      city: "",
                    }));
                    setSelectedProvinceName(selectedProvince?.name || "");
                    getRegionsForProvince(selectedValue);
                  }
                }}
                value={formData.province || ""}
              >
                <SelectTrigger
                  onMouseDown={(e) => {
                    if (!formData.country) {
                      e.preventDefault(); // Prevent open if no country is selected
                    }
                  }}
                  className={`w-full px-3 border rounded-md h-[40px] ${!formData.country ? "cursor-not-allowed opacity-50" : ""
                    }`}
                >
                  <SelectValue placeholder="Select State/Province" />
                </SelectTrigger>

                <SelectContent className="max-h-[200px] overflow-y-auto">
                  <SelectItem value="clear" className="text-red-500 italic">
                    Clear selection
                  </SelectItem>

                  {provinceOptions && provinceOptions.length > 0 ? (
                    provinceOptions.map((province) => (
                      <SelectItem key={province.id} value={province.id + ""}>
                        {province.name}
                      </SelectItem>
                    ))
                  ) : (
                    <SelectItem value="NA" disabled>
                      No data available
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="region" className="block text-sm font-medium text-gray-700">
              Region <span className="text-red-500"></span>
            </label>
            <div className="relative">
              <Select
                onValueChange={(selectedValue) => {
                  if (selectedValue === "clear") {
                    setFormData((prev) => ({
                      ...prev,
                      region: "",
                      // regionName: "",
                      county: "",
                      city: "",
                    }));
                    return;
                  }

                  const selectedRegion = regionOptions.find(
                    (r) => r.id.toString() === selectedValue
                  );

                  setFormData((prev) => ({
                    ...prev,
                    region: selectedValue,
                    // regionName: selectedRegion?.name || "",
                    county: "",
                    city: "",
                  }));

                  if (formData.province) {
                    setSelectedregionName(selectedRegion?.name || "");
                    getCountiesForProvinceAndRegion(formData.province, selectedValue);
                  }
                }}
                value={formData.region || ""}
              >
                <SelectTrigger
                  onMouseDown={(e) => {
                    if (!formData.country) {
                      e.preventDefault(); // Prevent open if no country is selected
                    }
                  }}
                  className={`w-full px-3 border rounded-md h-[40px] ${!formData.country ? "cursor-not-allowed opacity-50" : ""
                    }`}
                >
                  <SelectValue placeholder="Select Region" />
                </SelectTrigger>

                <SelectContent className="max-h-[200px] overflow-y-auto">
                  <SelectItem value="clear" className="text-red-500 italic">
                    Clear selection
                  </SelectItem>

                  {regionOptions && regionOptions.length > 0 ? (
                    regionOptions.map((region) => (
                      <SelectItem key={region.id} value={region.id + ""}>
                        {region.name}
                      </SelectItem>
                    ))
                  ) : (
                    <SelectItem value="NA" disabled>
                      No data available
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>

          {(selectedCountryName === 'United States' &&
            <div className="space-y-2">
              <label htmlFor="county" className="block text-sm font-medium text-gray-700">
                County <span className="text-red-500"></span>
              </label>
              <div className="relative">
                <Select
                  onValueChange={(selectedValue) => {
                    if (selectedValue === "clear") {
                      setFormData((prev) => ({
                        ...prev,
                        county: "",
                        // countyName: "",
                        city: "",
                      }));
                      getCitiesOptions("");
                    } else {
                      const selectedCounty = countyOptions?.find(
                        (c) => c.id.toString() === selectedValue
                      );
                      setFormData((prev) => ({
                        ...prev,
                        county: selectedValue,
                        // countyName: selectedCounty?.name || "",
                        city: "",
                      }));
                      getCitiesOptions(selectedValue);
                      setSelectedcountyName(selectedCounty?.name || "");
                    }
                  }}
                  value={formData.county || ""}
                  disabled={!formData.region}
                >
                  <SelectTrigger
                    onMouseDown={(e) => {
                      if (!formData.region) e.preventDefault();
                    }}
                    className={`w-full px-3 border rounded-md h-[40px]${!formData.region ? "cursor-not-allowed opacity-50" : ""
                      }`}
                  >
                    <SelectValue placeholder="Select County" />
                  </SelectTrigger>

                  <SelectContent className="max-h-[200px] overflow-y-auto">
                    <SelectItem value="clear" className="text-red-500 italic">
                      Clear selection
                    </SelectItem>

                    {countyOptions && countyOptions.length > 0 ? (
                      countyOptions.map((county) => (
                        <SelectItem key={county.id} value={county.id.toString()}>
                          {county.name}
                        </SelectItem>
                      ))
                    ) : (
                      <SelectItem value="NA" disabled>
                        No data available
                      </SelectItem>
                    )}
                  </SelectContent>
                </Select>

                <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
              </div>
            </div>
          )}


          <div className="space-y-2">
            <label htmlFor="city" className="block text-sm font-medium text-gray-700">
              City <span className="text-red-500"></span>
            </label>
            <div className="relative">
              <Select
                onValueChange={(selectedValue) => {
                  if (selectedValue === "clear") {
                    setFormData((prev) => ({
                      ...prev,
                      city: "",
                      // cityName: "",
                    }));
                  } else {
                    const selectedCity = cityOptions.find(
                      (c) => c.id.toString() === selectedValue
                    );
                    setFormData((prev) => ({
                      ...prev,
                      city: selectedValue,
                      // cityName: selectedCity?.name || "",
                    }));
                    setSelectedcityName(selectedCity?.name || "");
                  }
                }}
                value={formData.city || ""}
                disabled={
                  (selectedCountryName === "United States" && !formData.county) ||
                  (selectedCountryName === "Canada" && !formData.region)
                }
              >
                <SelectTrigger
                  onMouseDown={(e) => {
                    const shouldBlock =
                      (selectedCountryName === "United States" && !formData.county) ||
                      (selectedCountryName === "Canada" && !formData.region);
                    if (shouldBlock) e.preventDefault();
                  }}
                  className={`w-full px-3 border rounded-md h-[40px] ${(selectedCountryName === "United States" && !formData.county) ||
                    (selectedCountryName === "Canada" && !formData.region)
                    ? "cursor-not-allowed opacity-50"
                    : ""
                    }`}
                >
                  <SelectValue placeholder="Select City" />
                </SelectTrigger>

                <SelectContent className="max-h-[200px] overflow-y-auto">
                  <SelectItem value="clear" className="text-red-500 italic">
                    Clear selection
                  </SelectItem>

                  {cityOptions.length > 0 ? (
                    cityOptions.map((city) => (
                      <SelectItem key={city.id} value={city.id.toString()}>
                        {city.name}
                      </SelectItem>
                    ))
                  ) : (
                    <SelectItem value="NA" disabled>
                      No cities found
                    </SelectItem>
                  )}
                </SelectContent>
              </Select>

              <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" />
            </div>
          </div>


          {/* <div className="space-y-2">
            <label htmlFor="city" className={labelStyle}>
              City <span className="text-red-500">*</span>
            </label>
            <input
              id="city"
              name="city"
              className={inputStyle}
              placeholder="Enter City"
              value={formData.city}
              onChange={handleInputChange}
            />
          </div> */}

          <div className="space-y-2">
            <label htmlFor="latitude" className={labelStyle}>
              Latitude
            </label>
            <input
              id="latitude"
              name="latitude"
              type="number"
              className="w-full px-3 border rounded-md h-[40px]"
              placeholder="Enter Latitude"
              value={formData.latitude ?? ""}
              onChange={handleInputChange}
              min={-90}
              max={90}
            />
            {latitudeError && (
              <p className="text-sm text-red-600">{latitudeError}</p>
            )}
          </div>


          <div className="space-y-2">
            <label htmlFor="longitude" className={labelStyle}>
              Longitude
            </label>
            <input
              id="longitude"
              name="longitude"
              type="number"
              className="w-full px-3 border rounded-md h-[40px]"
              placeholder="Enter Longitude"
              value={formData.longitude ?? ""}
              onChange={handleInputChange}
              min={-180}
              max={180}
            />
            {longitudeError && (
              <p className="text-sm text-red-600">{longitudeError}</p>
            )}
          </div>
        </div>

        {/* Builder Information */}
        <div className="mb-10">
          <h2 className="text-xl font-medium mb-7">Builder Information</h2>

          <div className="grid lg:grid-cols-2 xl:grid-cols-3 14xl:grid-cols-4 gap-x-5 gap-y-6">
            <div className="space-y-2">
              <label htmlFor="builderName" className={labelStyle}>
                Builder Name *
              </label>
              <input
                id="builderName"
                name="builderName"
                className="w-full px-3 border rounded-md h-[40px]"
                placeholder="Enter Builder Name"
                value={formData.builderName}
                onChange={handleInputChange}
              />
            </div>

            {/* <div className="space-y-2">
              <label htmlFor="buildPhone" className={labelStyle}>
                Builder Phone
              </label>
              <input
                id="buildPhone"
                name="buildPhone"
                className={inputStyle}
                placeholder="Enter Builder Phone"
                value={formData.buildPhone}
                onChange={handleInputChange}
              />
            </div> */}
            <div className="space-y-2">
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700"
              >
                Builder Phone
              </label>
              {/* <PhoneInput
              value={formData.buildPhone}
              country={formData.country}
              onSubmit={(ans: string | string[]) => {
                const phoneNumber = Array.isArray(ans) ? ans[0] : ans;
                setFormData((prev) => ({ ...prev, phoneNumber }));
              }}
              onValidityChange={(valid: boolean) => setIsPhoneValid(valid)}
              placeholder="Enter Phone"
              className='p-0'
              inputComponent={(props : InputHTMLAttributes<HTMLInputElement>) => <input {...props} className="w-full px-3 py-2 rounded-md h-[40px] focus:outline-none focus:ring-2" />}
            /> */}
              <PhoneInput
                value={formData.buildPhone}
                country={formData.country}
                onSubmit={(buildPhone: string | string[]) => {
                  const num = Array.isArray(buildPhone) ? buildPhone[0] : buildPhone;
                  setFormData(prev => ({ ...prev, buildPhone: num }));
                }}
                onValidityChange={(valid: boolean) => setIsPhoneValid(valid)}
                placeholder="Enter Phone"
                className="w-full px-3 py-2 rounded-md h-[40px] focus:outline-none focus:ring-2"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="builderEmail" className={labelStyle}>
                Builder Email
              </label>
              <input
                id="builderEmail"
                name="builderEmail"
                className="w-full px-3 border rounded-md h-[40px]"
                placeholder="Enter Builder Email"
                value={formData.builderEmail}
                onChange={handleInputChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="builderWebsite" className={labelStyle}>
                Builder Website
              </label>
              <input
                id="builderWebsite"
                name="builderWebsite"
                className="w-full px-3 border rounded-md h-[40px]"
                placeholder="Enter Builder Website"
                value={formData.builderWebsite}
                onChange={handleInputChange}
              />
            </div>
          </div>
        </div>

        {/* Project Images */}
        <div className="mb-8">
          <h2 className="text-xl font-medium mb-4">Project Images</h2>

          <div className="flex flex-wrap gap-5">
            {/* Display uploaded images */}
            {projectImagesPreview.map((image, index) => (
              <div
                key={image.id}
                className="w-64 h-44 relative rounded-xl overflow-hidden border border-[#dadada]"
              >
                <img
                  src={image.preview}
                  alt={`image ${(index + 1).toString()}`}
                  className="w-64 h-44 object-cover"
                />
                <button
                  type="button"
                  onClick={() => removeImage(image.id)}
                  className="absolute top-2 right-2 bg-slate-100 rounded-full p-1 shadow-md"
                >
                  <X className="h-5 w-5 text-gray-500" />
                </button>
              </div>
            ))}

            {/* Upload button */}
            <div className="border border-dashed border-[#dadada] rounded-xl flex flex-col items-center justify-center w-64 h-44 cursor-pointer">
              <label
                htmlFor="image-upload"
                className="flex items-center justify-center w-full h-full cursor-pointer gap-2"
              >
                <span className="text-base font-medium text-[#363636]">
                  Upload
                </span>
                <img src={uploadIcon} alt="upload icon" />
                <input
                  id="image-upload"
                  type="file"
                  multiple
                  accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                  className="hidden"
                  onChange={handleImageUpload}
                />
              </label>
            </div>
          </div>
        </div>

        {/* Form Actions */}
        <div className="flex justify-end space-x-4">
          <Button
            onClick={() => navigate(`/profile/company-profile`)}
            className="px-11 py-3 border border-bmpGreen-500 rounded-lg text-lg font-semibold text-bmpGreen-500 bg-white hover:bg-gray-50"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!isFormValid}
            className={`px-11 py-3 rounded-lg text-lg font-semibold text-white bg-bmpGreen-500 hover:bg-bmpGreen-600 ${isFormValid ? "" : "cursor-not-allowed"}`}
          >
            Save Details
          </Button>
        </div>
      </div>
    </div>
  );
}

export function objectToFormData(data: BuilderProject): FormData {
  const form = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      !(typeof value === "string" && value.trim() === "")
    ) {
      if (Array.isArray(value)) {
        if (key === "projectImages") {
          //  Directly append projectImages array items as File objects
          value.forEach((item: File, index) => {
            if (item instanceof File) {
              console.log(index)
              form.append(`${key}`, item); // keep key same for all files
            }
          });
        } else {
          // default array handling
          value.forEach((item, index) => {
            if (item !== null && item !== undefined && String(item).trim() !== "") {
              form.append(`${key}[${index}]`, String(item));
            }
          });
        }
      } else if (value instanceof File) {
        form.append(key, value);
      } else {
        form.append(key, String(value));
      }
    }
  });

  return form;
}
